import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  // 切换路由时滚动到页面顶部；返回/前进时保留浏览位置
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      // 如有锚点，考虑固定头部80px的遮挡（可按需调整）
      return { selector: to.hash, offset: { x: 0, y: 80 } }
    }
    return { x: 0, y: 0 }
  },
  routes: [
    // Login 独立路由，不使用 Layout 布局
    {
      path: "/login",
      name: "Login",
      component: resolve => require(['@/pages/login'],resolve),
      meta: {requireAuth: false},
    },
    // 对话灵悦申请表单（独立路由）
    {
      path: "/lingyue-dialog-apply",
      name: "LingyueDialogApply",
      component: resolve => require(['@/pages/LingyueDialogApplyPage'], resolve),
      meta: { requireAuth: false }
    },
    // 其他页面使用 Layout 布局
    {
      path: '',
      component: resolve => require(['@/pages/Layout'],resolve),
      children:[
        {
          path: "/",
          name: "Home",
          component: resolve => require(['@/pages/HomePage'],resolve),
          meta: {requireAuth: false},
        },
        {
          path: "/vision",
          name: "Vision",
          component: resolve => require(['@/pages/VisionPage'],resolve),
          meta: {requireAuth: false}
        },
        {
          path: "/about",
          name: "About",
          component: resolve => require(['@/pages/AboutPage'],resolve),
          meta: {requireAuth: false}
        },
        {
          path: "/product-vision",
          name: "ProductVision",
          component: resolve => require(['@/pages/ProductVision'],resolve),
          meta: {requireAuth: false}
        },
        {
          path: "/product-voice",
          name: "ProductVoice",
          component: resolve => require(['@/pages/ProductVoice'],resolve),
          meta: {requireAuth: false}
        },
        {
          path: "/about-lingxin",
          name: "AboutNew",
          component: resolve => require(['@/pages/AboutLingxin'],resolve),
          meta: {requireAuth: false}
        },
        {
          path: "/products",
          name: "Products",
          component: resolve => require(['@/pages/ProductsPage'],resolve),
          meta: {requireAuth: false}
        },
        {
          path: "/lingyue-chat",
          name: "LingyueChat",
          component: resolve => require(['@/pages/LingyueChatPage'],resolve),
          meta: {requireAuth: false}
        },
        {
          path: "/services",
          name: "Services",
          component: resolve => require(['@/pages/ServicesPage'],resolve),
          meta: {requireAuth: false}
        },
        {
          path: "/solutions",
          name: "Solutions",
          component: resolve => require(['@/pages/SolutionsPage'],resolve),
          meta: {requireAuth: false}
        },
        {
          path: "/contact",
          name: "Contact",
          component: resolve => require(['@/pages/ContactPage'],resolve),
          meta: {requireAuth: false}
        },
         {
          path: "/counselservices",
          name: "CounselServices",
          component: resolve => require(['@/pages/CounselingServicesPage'],resolve),
          meta: {requireAuth: false}
        },
        {
          path: "/service-center",
          name: "ServiceCenter",
          component: resolve => require(['@/pages/ServiceCenterPage'],resolve),
          meta: {requireAuth: false}
        },
        {
          path: "/help-center",
          name: "HelpCenter",
          component: resolve => require(['@/pages/HelpCenterPage'],resolve),
          meta: {requireAuth: false}
        },
        {
          path: "/trial-apply",
          name: "TrialApply",
          component: resolve => require(['@/pages/TrialApplicationPage'], resolve),
          meta: { requireAuth: false }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js